<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <span
    role="link"
    aria-disabled="true"
    aria-current="page"
    :class="cn('tw-font-normal tw-text-neutral-950 dark:tw-text-neutral-50', props.class)"
  >
    <slot />
  </span>
</template>
